import OrderOptimizerTaxiListingTableColumn from "../common/types/order-optimizer-taxi-listing-table-column";

const getColumns = (): OrderOptimizerTaxiListingTableColumn[] => {
  const tableColumns: OrderOptimizerTaxiListingTableColumn[] = [
    {
      header: "",
      title: "",
      accessor: "row",
    },
  ];
  return tableColumns;
};

const orderOptimizerTaxiListingTableHelper = { getColumns };

export default orderOptimizerTaxiListingTableHelper;
